import { render } from "./AiChatView.vue?vue&type=template&id=45525b8f&scoped=true"
import script from "./AiChatView.vue?vue&type=script&lang=js"
export * from "./AiChatView.vue?vue&type=script&lang=js"

import "./AiChatView.vue?vue&type=style&index=0&id=45525b8f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45525b8f"]])

export default __exports__